export enum NavigationAttributes {
  NAVIGATION = 'navigation',
}

export const navigationAttributes = {};

export const navigationClassAttributes = {
  [NavigationAttributes.NAVIGATION]: 'linklist',
};
